import { styled } from '../../Utilities';
import { getStyles } from './GroupFooter.styles';
import { GroupFooterBase } from './GroupFooter.base';
export var GroupFooter = styled(GroupFooterBase, getStyles, undefined, {
    scope: 'GroupFooter',
});
//# sourceMappingURL=GroupFooter.js.map